import { FC, useCallback } from "react";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { ECONTRACT_STATUS } from "../../../enums";
import classNames from "classnames";
import { GET_MILESTONE_STATUSES } from "../../../components/contract/milestones/constants";

interface ContractListItemProps {
  // placeholders for dynamic fields
  title?: string;
  description?: string;
  shortId?: string;
  status?: string;
  itemPrice?: number;
  milestoneCount?: number;
  partiesCount?: number;
  onClick?: () => void;
}

const ContractListItem: FC<ContractListItemProps> = ({
  title = "Contract Title Placeholder",
  description = "#XXXXXX",
  shortId = "#XXXXXX",
  status = "DRAFT",
  milestoneCount,
  partiesCount = 0,
  itemPrice,
  onClick,
}) => {
  const { t } = useTranslation();

  const isMilestoneContract = typeof milestoneCount !== "number";
  const complexStatusMap = {
    [ECONTRACT_STATUS.DRAFT]: t("lbl_draft"),
    [ECONTRACT_STATUS.CREATED]: t("global_status_payment_title"),
    [ECONTRACT_STATUS.IN_PROGRESS]: t("lbl_in_progress"),
    [ECONTRACT_STATUS.COMPLETED]: t(
      "lbl_contract_details_completed_state_title"
    ),
  };
  const { seller: milestoneStatusMap } = GET_MILESTONE_STATUSES(t);

  const onCopy = useCallback(
    async (e) => {
      try {
        e?.stopPropagation();
        await navigator?.clipboard?.writeText(shortId);
      } catch (error) {
        console.error(error);
      }
    },
    [shortId]
  );

  return (
    <div className={styles.container} onClick={onClick} role="button">
      <div className={styles.headerRow}>
        <div className={styles.titleBlock}>
          <h4 className={styles.title}>{title}</h4>
          <p className={styles.description}>{description}</p>
        </div>
        <div
          className={classNames(styles.statusPill, {
            [styles.statusActive]: status !== ECONTRACT_STATUS.DRAFT,
          })}>
          <p>
            {isMilestoneContract
              ? milestoneStatusMap[status]?.title
              : complexStatusMap[status]}
          </p>
        </div>
      </div>

      <div className={styles.metaRow}>
        <div className={styles.metaItem}>
          <p className={styles.metaLabel}>
            {`كود ${isMilestoneContract ? "المعاملة" : "المشروع"}`}
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "9px",
            }}>
            <p className={styles.metaValue}>{shortId}</p>
            <img
              onClick={onCopy}
              alt="copy"
              src="/assets/images/svg/copy.svg"
              style={{ alignSelf: "flex-start", cursor: "pointer" }}
            />
          </div>
        </div>
        <div className={styles.metaItem}>
          <p className={styles.metaLabel}>الأطراف</p>
          <p className={styles.metaValue}>{partiesCount}</p>
        </div>
        {!isMilestoneContract && (
          <div className={styles.metaItem}>
            <p className={styles.metaLabel}>المعاملات</p>
            <p className={styles.metaValue}>{milestoneCount}</p>
          </div>
        )}
        <div
          style={{ marginRight: "auto", alignSelf: "center" }}
          className={styles.metaItem}>
          <p className={styles.priceLabel}>
            {itemPrice?.toLocaleString()} {t("lbl_saudi_currency")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContractListItem;
